import React from "react";
import classes from "../styles/Error.module.css";
const Error = () => {
  return (
    <div className={classes.error}>
      <h1>404 content not found</h1>
    </div>
  );
};

export default Error;
